import React from "react";
import { CustomerPassTypedRoute } from "@customer-pass/definitions/routeDefinitions";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { redirectOnFrontend } from "@novel/shared/utils/locationUtils";
import { appPrefixedHostWithProtocol, NOVEL_PASS_USER_EMAIL_PARAM } from "@novel/shared/utils/appConstants";
import { FixedCenteredLoader } from "@novel/shared/components/CenteredLoader";
const GoogleAuthPage: CustomerPassTypedRoute<"/oauth/google"> = ({
  props
}) => <React.Fragment>
        <GoogleOAuthProvider clientId={process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID!} onScriptLoadSuccess={() => {
    const client = google.accounts.oauth2.initCodeClient({
      client_id: process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID!,
      hint: props[NOVEL_PASS_USER_EMAIL_PARAM],
      state: props.originalUrl,
      scope: "email profile openid",
      ux_mode: "redirect",
      redirect_uri: `${appPrefixedHostWithProtocol}/api/customer/auth/passwordless/google-auth`,
      // applying optimization: https://developers.google.com/identity/openid-connect/openid-connect#hd-param
      hosted_domain: "*"
    });
    if (props.originalUrl) {
      client.requestCode();
    }
  }} onScriptLoadError={() => {
    redirectOnFrontend(props.originalUrl);
  }}>
            {/* element is expected */}
            <div style={{
      visibility: "hidden"
    }} />
        </GoogleOAuthProvider>
        <FixedCenteredLoader />
        <style global jsx>{`
            body {
                background: white !important;
            }
        `}</style>
    </React.Fragment>;
GoogleAuthPage.isPublicRoute = true;
GoogleAuthPage.isLoggedOutRoute = true;
export default GoogleAuthPage;